import { useEffect, useState } from "react";
import {
  SCREENS,
  shikshakInstructionContent,
} from "../utils/CommonUtils/constants";
import OnBoardingScreen from "../screens/OnBoardingScreen/OnBoardingScreen";
import NeedPermissionsScreen from "../screens/NeedPermissionsScreen/NeedPermissionsScreen";
import VopaInstructionScreen from "../screens/VopaInstructionScreen/VopaInstructionScreen";
import AssessmentLoadingScreen from "../screens/AssessmentLoadingScreen/AssessmentLoadingScreen";
import AssessmentScreen from "../screens/assessmentScreen/AssessmentScreen";
import useTranslationSetup from "../utils/useTranslationSetup";

const AssessmentFlow = () => {
  const { t } = useTranslationSetup();
  const [activeScreen, setActiveScreen] = useState(
    SCREENS.RENDER_ONBOARDING_SCREEN
  );
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [createAssessmentResponse, setCreateAssessmentResponse] =
    useState(null);
  const [primaryAssessmentId, setPrimaryAssessmentId] = useState(null);

  const renderActiveScreen = () => {
    switch (activeScreen) {
      case SCREENS.RENDER_ONBOARDING_SCREEN:
        return <OnBoardingScreen setActiveScreen={setActiveScreen} />;
      case SCREENS.RENDER_NEED_PERMISSION_SCREEN:
        return (
          <NeedPermissionsScreen
            setActiveScreen={setActiveScreen}
            setLatitude={setLatitude}
            setLongitude={setLongitude}
          />
        );
      case SCREENS.RENDER_INSTRUCTIONS_SCREEN:
        return (
          <VopaInstructionScreen
            instructionContent={shikshakInstructionContent(t, "assessment")}
            setActiveScreen={setActiveScreen}
            flowType="assessment"
          />
        );
      case SCREENS.RENDER_ASSESSMENT_LOADING_SCREEN:
        return (
          <AssessmentLoadingScreen
            currentStep={currentStep}
            setCreateAssessmentResponse={setCreateAssessmentResponse}
            primaryAssessmentId={primaryAssessmentId}
            latitude={latitude}
            longitude={longitude}
          />
        );
      case SCREENS.RENDER_ASSESSMENT_SCREEN:
        return (
          <AssessmentScreen
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            createAssessmentResponse={createAssessmentResponse}
            setActiveScreen={setActiveScreen}
          />
        );
      default:
        break;
    }
  };

  useEffect(() => {
    if (createAssessmentResponse) {
      if (currentStep === 1) {
        setPrimaryAssessmentId(createAssessmentResponse?.id);
      }
      setActiveScreen(SCREENS.RENDER_ASSESSMENT_SCREEN);
    }
  }, [createAssessmentResponse]);

  return <>{renderActiveScreen()}</>;
};

export default AssessmentFlow;
